import { AIEngineConfiguration, ModelDefinitionDto, ModelFileStorageInfo, ModelTypes, PerformanceStats, SocialStatusInfo } from '../../models/APIModels';


export class ModelForm {
  modelId: string | null = null;
  modelName: string | null = '';
  modelDescription: string | null = '';
  modelLongDescription: string | null = '';
  externalRedirectUrl:string | null = null;
  author: string = '';
  authorUserId: string = '';
  parentRepositoryId: string | null = null;
  modelData: ModelFileStorageInfo = { filePaths: null };
  modelType: ModelTypes = ModelTypes.HostedModel;
  active: boolean = false;
  usageCharge: number = 0.0;
  isPublic: boolean = false;
  totalCost: number = 0.0;
  performanceStats: PerformanceStats = { matrics: {} };
  socialStatus: SocialStatusInfo | null = null;
  aiEngineConfig:AIEngineConfiguration | null = null;
  orginalUserModelData:ModelDefinitionDto | null = null;
  id: string | null = null;
  websiteUrl:string = '';
  entityType: string = 'ModelDefinition';


  static CreateForm(author: string, authorUserId: string) {
    const form = new ModelForm();
    form.author = author;
    form.authorUserId = authorUserId;
    return form;
  }

  static CreateFormData(model:ModelDefinitionDto){
    const form = new ModelForm();
    form.author = model.author;
    form.modelId = model.modelId;
    form.modelName = model.modelName;
    form.modelDescription = model.modelDescription;
    form.modelLongDescription = model.modelLongDescription;
    form.externalRedirectUrl = model.externalRedirectUrl;
    form.modelType = model.modelType;
    form.parentRepositoryId = model.parentRepositoryId;
    form.active = model.active;
    form.usageCharge = model.usageCharge;
    form.isPublic = model.isPublic;
    form.performanceStats = model.performanceStats;
    form.socialStatus = model.socialStatus;
    form.id = model.id;
    form.aiEngineConfig = model.aiEngineConfig;
  }
}
